import React from 'react';
import ListWrapper from './list-wrapper';
import ContentTypes from '../../../utils/content-types';

export default class EmptyList extends React.Component {

    updateNestedItem = (key, value) => {
        const { card, name } = this.props;
        this.props.updateNestedItem(name, { ...card, [key]: value });
    };

    addNewItem = (type) => {
        this.updateNestedItem(type.toLowerCase(), [ContentTypes[type].build()]);
    };

    render() {
        const { card, links } = this.props;

        return (
            <ListWrapper
                {...card} links={links}
                updateNestedItem={this.updateNestedItem}
                addNewItem={this.addNewItem}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/section/components/empty-list.js